import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import gradoLogo from '../images/grado.png'; // Update the path to your grado.png file
import { logoutUser } from '../redux/actions/thunks/Auth.js'; // Import logoutUser thunk
import { orderModified } from '../redux/actions/ordersAction.js';
import { FaEllipsisV } from 'react-icons/fa'; // Import the 3 dots icon

const NavigationBar = () => {
  const { pathname } = useLocation();
  const currentUser = useSelector(state => state.users.currentUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const orderState = useSelector(state => state.orders.isModified);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State to handle dropdown visibility

  const token = localStorage.getItem('token');

  if (!token) {
    return null;
  }

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate('/login');
    setIsDropdownOpen(false);
  };

  const handleNavigation = (e) => {
    if (orderState && !window.confirm('Muokkauksia ei ole tallennettu. Haluatko poistua sivulta tallentamatta?')) {
      e.preventDefault();
    } else if (orderState) {
      dispatch(orderModified(false)); // Set orderState to false when confirmed
    }
    setIsDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <nav className="navbar dot-matrix">
      <Link to="/calendar" onClick={handleNavigation}>
        <img src={gradoLogo} alt="Grado Logo" className="navbar-logo" />
      </Link>
      <ul className="navbar-list">
        <li className="navbar-item">
          <Link to="/calendar" className={`navbar-link ${pathname === '/calendar' ? 'active' : ''}`} id="calendar-link" onClick={handleNavigation}>
            KALENTERI
          </Link>
        </li>
        <li className="navbar-item">
          <Link to="/storage" className={`navbar-link ${pathname === '/storage' ? 'active' : ''}`} id="storage-link" onClick={handleNavigation}>
            VARASTO
          </Link>
        </li>
        <li className="navbar-item">
          <Link to="/orders" className={`navbar-link ${pathname === '/orders' ? 'active' : ''}`} id="orders-link" onClick={handleNavigation}>
            TILAUKSET
          </Link>
        </li>
        <li className="navbar-item">
          <Link to="/colors" className={`navbar-link ${pathname === '/colors' ? 'active' : ''}`} id="colors-link" onClick={handleNavigation}>
            SÄVYT
          </Link>
        </li>
        <li className="navbar-item">
          <Link to="/holidays" className={`navbar-link ${pathname === '/holidays' ? 'active' : ''}`} id="holidays-link" onClick={handleNavigation}>
            LOMAT
          </Link>
        </li>
      </ul>
      <div className="navbar-dropdown">
        <button className="navbar-menu-button" onClick={toggleDropdown} aria-haspopup="true" aria-expanded={isDropdownOpen}>
          <FaEllipsisV />
        </button>
        {isDropdownOpen && (
          <div className="dropdown-menu">
            {currentUser && (
              <div className="dropdown-header">
                <span className="dropdown-user-label">Kirjautuneena</span>
                <span className="dropdown-user-name">{currentUser.username}</span>
              </div>
            )}
            <div className="dropdown-group">
              {(currentUser.role === 'admin' || currentUser.role === 'design') && (
              <Link to="/resources" className={`dropdown-link ${pathname === '/resources' ? 'active' : ''}`} onClick={toggleDropdown}>
                RESURSSIT
              </Link>
              )}
              {currentUser.role === 'admin' && (
                <Link to="/users" className={`dropdown-link ${pathname === '/users' ? 'active' : ''}`} onClick={toggleDropdown}>
                  KÄYTTÄJÄT
                </Link>
              )}
            </div>
            <div className="dropdown-footer">
              <button className="ghost-button danger dropdown-logout" onClick={() => { handleLogout(); toggleDropdown(); }}>
                Kirjaudu ulos
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default NavigationBar;
